<template>
    <div class="af3-shortcodes-single-related-component" v-if="floor_plan.related_floor_plans.length > 0">

      <h2>{{ options.single_floor_plan_related_title }}</h2>

      <div class="af3-shortcodes-single-related-component-body">

          <template v-for="floor_plan in floor_plan.related_floor_plans" :key="floor_plan.id"> 
              <template v-if="options.floor_plans_loop_link_floorplans"> 
                <a :href="floor_plan.link_floorplan" class="af3-floor-plan-card-link" style="background-color: transparent !important;">
                  <floor-plan-card-component :floor_plan="floor_plan" :options="options" :selected_lease_term="selected_lease_term" />
                </a>
              </template>
              <template v-else> 
                <floor-plan-card-component :floor_plan="floor_plan" :options="options" :selected_lease_term="selected_lease_term" />
              </template>
          </template>

      </div>

    </div>
</template>
  
<script>

import { defineComponent, ref, watch, onMounted, reactive  } from 'vue';
import FloorPlanCardComponent from '../loop/FloorPlanCardComponent.vue';

export default defineComponent({
    components: { FloorPlanCardComponent },
   
    props: { 
      options: {
        type: Object,
        required: true
      },
      floor_plan: {
        type: Object,
        required: true
      },
    },

    
    setup(props) {

          

    return {
        
    };
  },


  
  
});
</script>